export const LABEL_SUGGESTIONS = [
  {
    label: 'To respond',
    default: true,
    value: {
      name: 'To respond',
      description:
        'Emails that require a reply or action from the recipient but have not yet been answered.',
    },
  },
  {
    label: 'FYI',
    default: true,
    value: {
      name: 'FYI',
      description:
        'Informational messages that do not require action, just awareness.',
    },
  },
  {
    label: 'Comment',
    default: true,
    value: {
      name: 'Comment',
      description: 'Team chats in tools like Google Docs or Microsoft Office',
    },
  },
  {
    label: 'Notifications',
    default: true,
    value: {
      name: 'Notifications',
      description:
        'System-generated updates such as status alerts, system messages, or automated notices.',
    },
  },
  {
    label: 'Meeting update',
    default: true,
    value: {
      name: 'Meeting update',
      description:
        'Emails about new meetings, changes to scheduled meetings, or shared agendas.',
    },
  },
  {
    label: 'Awaiting reply',
    default: true,
    value: {
      name: 'Awaiting reply',
      description:
        'Messages previously sent by the user that are pending a response from the recipient.',
    },
  },
  {
    label: 'Actioned',
    default: true,
    value: {
      name: 'Actioned',
      description:
        'Emails that have already been responded to or where required tasks are completed.',
    },
  },
  {
    label: 'Marketing',
    default: true,
    value: {
      name: 'Marketing',
      description:
        'Campaigns, newsletters, and promotional content sent to or from marketing teams.',
    },
  },
  {
    label: 'Leads',
    value: {
      name: 'Leads',
      description:
        'Emails from potential customers or inquiries showing interest in products or services.',
    },
  },
  {
    label: 'Clients',
    value: {
      name: 'Clients',
      description:
        'Correspondence with existing customers, including support, account management, or updates.',
    },
  },
  {
    label: 'Invoices',
    value: {
      name: 'Invoices',
      description:
        'Messages that contain invoices, billing statements, or requests for payment.',
    },
  },
  {
    label: 'Receipts',
    value: {
      name: 'Receipts',
      description:
        'Emails confirming completed payments or purchases, often including proof of transaction.',
    },
  },
  {
    label: 'Orders',
    value: {
      name: 'Orders',
      description:
        'Emails related to sales or purchase orders, including confirmations and status updates.',
    },
  },
  {
    label: 'Support',
    value: {
      name: 'Support',
      description:
        'Messages related to technical issues, customer service, or help requests.',
    },
  },
  {
    label: 'Follow-up',
    value: {
      name: 'Follow-up',
      description:
        'Emails that revisit a prior conversation or remind about pending tasks or discussions.',
    },
  },
  {
    label: 'Internal',
    value: {
      name: 'Internal',
      description:
        'Messages exchanged within the organization or team, not involving external contacts.',
    },
  },
  {
    label: 'Legal',
    value: {
      name: 'Legal',
      description:
        'Emails containing contracts, agreements, regulatory content, or legal communication.',
    },
  },
  {
    label: 'Banking',
    value: {
      name: 'Banking',
      description:
        'Messages from financial institutions, including statements, transfers, or account activity.',
    },
  },
  {
    label: 'Events',
    value: {
      name: 'Events',
      description:
        'Invitations, registrations, or planning details related to business events or webinars.',
    },
  },
  {
    label: 'Newsletters',
    value: {
      name: 'Newsletters',
      description:
        'Periodic informational emails subscribed from external sources or internal teams.',
    },
  },
  {
    label: 'Urgent',
    value: {
      name: 'Urgent',
      description:
        'Time-sensitive emails requiring immediate attention, often marked by critical tone or deadlines.',
    },
  },
]
